

/// <reference path="ReportItem.ts" />

// Generated class ReportChartItem_ManagedObject

class ReportChartItem_ManagedObject extends ReportItem
{
}
